"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperText = exports.ClearIcon = exports.StyledForm = void 0;
const styles_1 = require("@mui/material/styles");
const form_1 = __importDefault(require("../form"));
const Cancel_1 = __importDefault(require("../icon/svgs/Cancel"));
exports.StyledForm = (0, styles_1.styled)(form_1.default)(({ theme }) => ({
    maxWidth: "800px"
}));
exports.ClearIcon = (0, styles_1.styled)(Cancel_1.default)(({ theme }) => ({
    fontSize: "1.25rem",
    color: theme.colours.slate
}));
exports.HelperText = (0, styles_1.styled)("p")(({ theme }) => ({
    color: theme.colours.slate,
    margin: 0,
    fontSize: "0.75rem",
    marginTop: "3px",
    lineHeight: 1.66
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlYXJjaC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLG1EQUEyQjtBQUMzQixpRUFBeUM7QUFFNUIsUUFBQSxVQUFVLEdBQUcsSUFBQSxlQUFNLEVBQUMsY0FBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3JELFFBQVEsRUFBRSxPQUFPO0NBQ2xCLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxTQUFTLEdBQUcsSUFBQSxlQUFNLEVBQUMsZ0JBQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN0RCxRQUFRLEVBQUUsU0FBUztJQUNuQixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0NBQzNCLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxVQUFVLEdBQUcsSUFBQSxlQUFNLEVBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3BELEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDMUIsTUFBTSxFQUFFLENBQUM7SUFDVCxRQUFRLEVBQUUsU0FBUztJQUNuQixTQUFTLEVBQUUsS0FBSztJQUNoQixVQUFVLEVBQUUsSUFBSTtDQUNqQixDQUFDLENBQUMsQ0FBQyJ9